import { render, staticRenderFns } from "./scaleIO.vue?vue&type=template&id=032855bc&"
import script from "./scaleIO.vue?vue&type=script&lang=js&"
export * from "./scaleIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports